import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
  icon,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-4 md:mb-5">
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          {icon && (
            <span className="w-6 h-6 flex items-center justify-center text-accent-500">
              <i className={`${icon} text-lg`} />
            </span>
          )}
          <h2 className="font-heading font-extrabold text-lg md:text-xl text-foreground-950 whitespace-nowrap">
            {title}
          </h2>
        </div>
        {subtitle && (
          <p className="mt-1 text-xs md:text-sm text-foreground-500 line-clamp-1">{subtitle}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 inline-flex items-center gap-0.5 text-sm text-primary-600 hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      )}
    </div>
  );
}